
//side effect update of local storage is defined in App.svelte

export const token = $state({
    access_token: localStorage.getItem('access_token')
});


export const user = $state(
    {
        data: {
            id: "",
            workspace_id: "",
            email: "",
            name: "",
            role: "",
            is_enabled: false,
            is_notification_enabled: false,
            last_login_at:"",
            language:""
        }
    }
);

export const assetsLimits = $state(
    {
        data:{
            active_directory_limit: 0,
            cloud_limit: 0,
            domain_limit: 0,
            email_limit: 0,
            endpoint_limit: 0,
            ip_limit: 0,
            network_limit: 0,
            private_network_limit: 0,
            private_ip_limit: 0,
            source_code_limit: 0,
        }
    }
)

export const workspacePlan = $state({data: ""});